






import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { Getter } from 'vuex-class';
import { getModule } from 'vuex-module-decorators';
import { postAdminLogout } from '@/configs/api-path';
import ApiStatusMixin from '@/mixins/api-status';
import ApiErrorMixin from '@/mixins/api-error';
import UserModule from '@/store/modules/user';
import getCookieName from '@/utils/cookie';
import { UserInfo } from '@/models/user';

@Component
export default class PageAuthLogout extends mixins(ApiStatusMixin, ApiErrorMixin) {
  userModule: UserModule | null = null;

  @Getter('user/currentUser') currentUser!: UserInfo | undefined;

  cleanCookie() {
    this.$cookie.remove(getCookieName('token'));
    this.$cookie.remove(getCookieName('admin'));
  }

  async doLogout() {
    this.setApiLoading();
    try {
      const currentUserId = this.currentUser?.id;

      const { data: logoutResponse } = await this.$axios.post<{
        code: number;
        admin: {
          id: number;
        };
      }>(postAdminLogout, {
        id: currentUserId,
      });

      console.log(`Logout user: ${logoutResponse.admin.id}`);

      // if (logoutResponse.code === 0) {
      //   if (this.userModule) {
      //     this.userModule.clearUser();
      //     this.cleanCookie();
      //   }
      //   this.$notify.show(
      //     'success filled',
      //     '您已成功登出',
      //     '金旺宏管理後台',
      //     { duration: 3000, permanent: false },
      //   );
      //   this.$router.push({
      //     name: 'auth-login',
      //   });
      // } else {
      //   // TODO: Confirm logout flow
      //   // this.apiErrorCodeAlert(logoutResponse.code);
      //   // this.$router.back();
      // }

      if (this.userModule) {
        this.userModule.clearUser();
        this.cleanCookie();
      }

      this.$notify.show('success filled', '您已成功登出', '金旺宏管理後台', { duration: 3000, permanent: false });
      this.$router.push({
        name: 'auth-login',
      });
    } catch (error) {
      console.error(error);
      this.$router.back();
    }
    this.setApiPending();
  }

  beforeMount() {
    this.userModule = getModule(UserModule, this.$store);
    this.doLogout();

    // this.userModule.clearUser();

    // this.$router.replace({
    //   name: 'auth-login',
    // });
  }
}
